import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CbHubTableModule} from '@app/shared/components/table/table.module';
import {CbInfoMessageModule, CbLoadingSpinnerModule, CbTableModule} from 'cb-hub-lib';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CbFormsModule} from '@app/shared/components/forms/forms.module';
import {MatTabsModule} from '@angular/material/tabs';
import {CbDialogModule} from '@app/shared/components/dialog/dialog.module';
import {CbDisplayValueModule} from '@app/shared/components/display-value/display-value.module';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTableModule} from '@angular/material/table';
import {CbClickModule} from '@app/shared/directives/click/click.module';
import {InfiniteScrollDirective} from 'ngx-infinite-scroll';
import {SlotExternalSystemFieldValueDialogComponent} from './slot-external-system-field-value-dialog/slot-external-system-field-value-dialog.component';
import {SlotExternalSystemFieldValueComponent} from './slot-external-system-field-value-search/slot-external-system-field-value.component';
import {MatSelectModule} from '@angular/material/select';

@NgModule({
    declarations: [
        SlotExternalSystemFieldValueComponent,
        SlotExternalSystemFieldValueDialogComponent
    ],
    imports: [
        MatTabsModule,
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        CbDialogModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
        CbFormsModule,
        CbDisplayValueModule,
        CbClickModule,
        CbHubTableModule,
        CbTableModule,
        InfiniteScrollDirective,
        MatSelectModule,
    ],
    exports: [
        SlotExternalSystemFieldValueComponent,
        SlotExternalSystemFieldValueDialogComponent
    ]
})
export class SlotExternalSystemFieldValueComponentModule { }
